import React from 'react';
import { FacebookIcon, InstagramIcon, MessageCircleIcon, SunIcon, YoutubeIcon } from 'lucide-react';
const SITE_URL = 'www.tufenixdigital.store';
const socials = [{
  icon: FacebookIcon,
  label: 'Facebook',
  href: 'https://www.facebook.com/people/Tu-Fenix-Digital/61590759474336/'
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  href: 'https://www.instagram.com/tufenixdigital_oficial/'
}, {
  icon: YoutubeIcon,
  label: 'YouTube',
  href: 'https://www.youtube.com/@TuFenixDigital'
}, {
  icon: MessageCircleIcon,
  label: 'WhatsApp',
  href: 'https://wa.me/59892165229?text=Hola,%20estuve%20viendo%20Aula%20de%20%C3%89xitos%20y%20tengo%20algunas%20consultas%20antes%20de%20comprar.'
}];
export function Footer() {
  return <footer className="bg-ink px-5 py-12 sm:px-8" data-id="element-51" data-mp="3qc445h4tcaoa">
      <div className="mx-auto w-full max-w-content text-center" data-id="element-52" data-mp="29zgkq0kfasm4">
        <p className="flex items-center justify-center gap-2 font-display text-[24px] font-bold text-white sm:text-[27px]" data-id="element-53" data-mp="29xvtajtenpsh">
          <SunIcon aria-hidden="true" className="h-6 w-6 text-butter" strokeWidth={2} data-id="element-54" data-mp="3l9k6xg5ljtev" />
          Tu Fénix Digital
        </p>
        <p className="mt-2 font-sans text-[15px] font-bold uppercase tracking-[0.06em] text-[#D98A55]" data-id="element-55" data-mp="3gb8v4zvqr8u0">
          Aula de Éxitos · Edición 2026
        </p>
        <a href={`https://${SITE_URL}`} className="mt-7 inline-block font-sans text-[15px] text-[#A9BBD1] underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:underline" data-id="element-56" data-mp="3v5n92m0g7s1t">
          {SITE_URL}
        </a>
        <nav aria-label="Redes sociales" className="mt-6 flex items-center justify-center gap-4" data-id="element-57" data-mp="34gvldp1el60">
          {socials.map(({
          icon: Icon,
          label,
          href
        }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white/70 transition-colors duration-150 ease-out hover:border-butter hover:text-butter" data-id="element-58" data-mp="ctqm4p48fvs0">
              <Icon aria-hidden="true" className="h-5 w-5" data-id="element-59" data-mp="mq3ftmzs29mr" />
            </a>)}
        </nav>
        <p className="mx-auto mt-8 max-w-[34ch] font-sans text-[14px] leading-relaxed text-white/60" data-id="element-60" data-mp="tt08mp9t0kpy">
          © 2026 Tu Fénix Digital — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}